import { Box, Grid } from "@mui/material";
import React, { useState } from "react";

const ImageSection = ({ specificAcc }) => {
  const [selectedPhoto, setSelectedPhoto] = useState(
    `${specificAcc.link}_1.jpg`
  );
  const [notSelected, setNotSelected] = useState([
    `${specificAcc.link}_2.jpg`,
    `${specificAcc.link}_3.jpg`,
    `${specificAcc.link}_4.jpg`,
    `${specificAcc.link}_5.jpg`,
  ]);

  return (
    <Grid container spacing={2} mb={{ xs: 6, md: 10 }}>
      <Grid item xs={12} md={7} display="flex" justifyContent="center">
        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
            "& img": {
              transition: "transform 0.5s ease",
            },
            "&:hover img": {
              transform: "scale(1.02)",
            },
          }}
        >
          <img
            src={require(`assets/images/${selectedPhoto}`)}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
            alt={specificAcc.name}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={5}>
        <Grid container spacing={2} sx={{ height: "100%" }}>
          {notSelected.map((photo, index) => (
            <Grid item xs={6} key={index} display="flex">
              <Box
                sx={{
                  width: "100%",
                  overflow: "hidden",
                  cursor: "pointer",
                  opacity: 0.85,
                  transition: "opacity 0.3s ease",
                  "&:hover": {
                    opacity: 1,
                  },
                  "& img": {
                    transition: "transform 0.5s ease",
                  },
                  "&:hover img": {
                    transform: "scale(1.05)",
                  },
                }}
              >
                <img
                  src={require(`assets/images/${photo}`)}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                  alt={specificAcc.name}
                  onClick={() => {
                    const save = selectedPhoto;
                    setSelectedPhoto(photo);
                    setNotSelected((prevPhotos) => {
                      const updatedPhotos = [...prevPhotos];
                      updatedPhotos.splice(index, 1, save);
                      return updatedPhotos;
                    });
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ImageSection;
